import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLargeDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconChevronLargeDown"><Path fillRule="evenodd" clipRule="evenodd" d="M2.10546 9.36681C2.31716 9.01078 2.77739 8.89377 3.13342 9.10546L11.3613 13.9977C11.755 14.2318 12.2452 14.2318 12.639 13.9977L20.8668 9.10546C21.2228 8.89377 21.6831 9.01078 21.8948 9.36681C22.1065 9.72284 21.9895 10.1831 21.6334 10.3948L13.4056 15.287C12.5394 15.802 11.4609 15.802 10.5947 15.287L2.36681 10.3948C2.01078 10.1831 1.89377 9.72284 2.10546 9.36681Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLargeDown;
